function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg height="32" width="32" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16.714 11.297a1.02 1.02 0 0 0-1.429 0l-8.999 8.976a1.008 1.008 0 1 0 1.428 1.426L16 13.436l8.285 8.264a1.012 1.012 0 0 0 1.429 0 1.008 1.008 0 0 0 0-1.426l-9-8.977z" fill="#4F5EA3" /></svg>;
});